

import { MessageBroadcastStatusEnum, MessageTypeEnum, PriorityEnum } from '@schemax-whatsapp/shared-models';
import { PrimaryGeneratedColumn, Index, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Generated } from 'typeorm';

@Entity('broadcast_contact')
export class BroadcastContact {

    @PrimaryGeneratedColumn('increment', {
        name: 'id'
    })
    id: number;

    @Column("int", {
        nullable: false,
        name: "bm_id"
    })
    bmId: number;

    @Column('varchar', {
        nullable: false,
        name: 'contact',
        length: 30
    })
    contact: string;

    @Column('varchar', {
        nullable: false,
        name: 'contact_type',
        length: 1,
        default: 'N'
    })
    contactType: string;

    @Column('varchar', {
        nullable: false,
        name: 'message_id',
        length: 50,
    })
    messageId: string;

    @Column('tinyint', {
        nullable: false,
        name: 'status',
        default: MessageBroadcastStatusEnum.PENDING
    })
    status: MessageBroadcastStatusEnum;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
}

